import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { GlobalService } from './global.service';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { LoaderService } from './loder_service/loader.service';
import { Storage } from '@ionic/storage';
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { DataService } from './data.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  public user_name:any;
  public user_image:any;
  public user_mobile:any;
  public user_id:any;
  public ishome:boolean=true;
  public refferal_id:any;
  public appPages = [
    {
      title: 'Sign In',
      url: '/signin',
      icon: 'log-in'
    },
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: 'home'
    },
    {
      title: 'Edit Profile',
      url: '/editprofile',
      icon: 'logo-angular'
    }
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public router:Router,
    public toastService:LoaderService,
    public storage:Storage,
    public globalService:GlobalService,
    private sanitizer: DomSanitizer,
    public push:Push,
    public restApi:DataService,
    public socialSharing:SocialSharing
  ) {
    this.initializeApp();
    this.initializeServiceApp()
   
      this.user_image=localStorage.getItem('user_image');
    
   
      this.user_id=localStorage.getItem('user_id');
      this.user_mobile=localStorage.getItem('user_mobile');
      this.user_name=localStorage.getItem('user_name');
      this.user_image=localStorage.getItem('user_image');
    
   
      if(this.user_id){

        this.user_id=this.user_id
        this.ishome=false;
        this.router.navigate(['/home'])
      }else{
        this.ishome=true;
        this.router.navigate(['/signin'])
      }
    
    
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.backgroundColorByHexString('#15224c');
      this.splashScreen.hide();
      this.initPushNotification()
    });
  }
  sign_out(){
    localStorage.clear();
    this.router.navigate(['/signin'])
    this.globalService.publishSomeData({
      user_id:null
  });
    this.toastService.create('You Have Successfully Logged Out')
   // this.ishome=true;
  }
  sign_in(){
    this.router.navigate(['/signin'])
  }

  register(){
    this.router.navigate(['/register'])
  }
  initializeServiceApp() {
    // other code

    this.globalService.getObservable().subscribe((data) => {
        //console.log('Data received', data);
        this.user_name=data.user_name
        this.user_mobile=data.user_mobile
        this.user_image=data.user_image
        this.user_id=data.user_id
        this.storage.set('userData',data)
        // this.storage.set('user_mobile',this.user_mobile)
        // this.storage.set('user_image',this.user_image)
    });
}
photoURL(url) {
  console.log(url)
  return this.sanitizer.bypassSecurityTrustResourceUrl(url);
 }
   //Push Notification
   saveDeviceToken(token)
   {
    
       let postparams={
         token:token,
       }
       this.restApi.savedevicetoken(postparams).subscribe((data:any)=>{
         //alert(JSON.stringify(data));
       },(error:any)=>{
         //alert(JSON.stringify(error));
       })
   
     //let token="hi";

 }
   initPushNotification()
   {
     //alert('its fire')
     // to check if we have permission
 this.push.hasPermission()
   .then((res: any) => {
 
     if (res.isEnabled) {
       console.log('We have permission to send push notifications');
     } else {
       console.log('We don\'t have permission to send push notifications');
     }
 
   });
 
 // to initialize push notifications
 
 const options: PushOptions = {
    android: {
        senderID: 'XXXXXXXXXXXXX'
    },
    ios: {
        alert: 'true',
        badge: true,
        sound: 'false'
    },
    windows: {}
 };
 
 const pushObject: PushObject = this.push.init(options);
 
 pushObject.on('notification').subscribe((notification: any) =>{
   console.log('Received a notification', notification);
 if(notification.message){
   //this.nav.push(NotificationPage)
 }

 });
 
 pushObject.on('registration').subscribe((registration: any) => {
   console.log('Device registered', registration);
  // alert(JSON.stringify(registration));
 
   this.saveDeviceToken(registration.registrationId);
 });
 
 pushObject.on('error').subscribe(error => console.error('Error with Push plugin', error));
   }
   share(){
     //alert('its fire')
    this.storage.get('refferal_id').then((refferal_id)=>{
      let refer = refferal_id
      //alert(refer)
      this.platform.ready().then(async () => {
        this.socialSharing.share('BDFShopping - Download App now','Refer and Earn', '', 'https://play.google.com/store/apps/details?id=com.bdfshopping.shopping&hl=en_IN').then(() => {
        
        }).catch(() => {
          //this.sendNotification(`Sorry, Something went wrong!`);
          this.toastService.create('Sorry, Something went wrong!')
        });
      });
    })

   }
}
